import {SOPutProduct} from '../../core/product/so-put-product';
import {ProductCore} from './product.core';
import {SOGetProduct} from '../../core/product/so-get-product';
import {FormField, SelectionOption} from 'lionheartland';
import {putProductFormFieldOptions} from './put-product-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';

export class RAPutProduct extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putProductFormFieldOptions);

  RequestClass = SOPutProduct

  constructor(
    public entityCore: ProductCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('sku'),
      this.getFormValueFromIdentifier('exRef'),
      this.getFormValueFromIdentifier('active'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}